import axios from 'axios';

function getCurrentProductRequestUrl() {
  switch (PUBLIC_PRODUCT.toLowerCase().trim()) {
    case 'yft':
      return request.yft;
    case 'yftzs':
      return request.yftzs;
    case 'cxyf':
      return request.cxyf;
    case 'cxyfzs':
      return request.cxyfzs;
    case 'cxpro':
    case 'cxplus':
      return request.cxplus;
    case 'cxpluszs':
      return request.cxpluszs;
    case 'hfplus':
      return request.hfplus;
    case 'hfpluszs':
      return request.hfpluszs;
    case 'xhgj':
      return request.xhgj;
    case 'cxzf':
      return request.cxzf;
    case 'cxzfzs':
      return request.cxzfzs;
    case 'cxzfpos':
      return request.cxzfpos;
    case 'cxzfposzs':
      return request.cxzfposzs;
    case 'xxwp':
      return request.xxwp;
    default:
      return request.yft;
  }
}

// 创建axios实例
const service = axios.create({
  // api 的 base_url
  // 设置为process.env.BASE_API是取config文件夹下dev.env.js/prod.env.js中配置的信息
  // 设置为reqCfg.requestUrl是取static文件夹下RequestConfig.js中配置的信息
  baseURL: getCurrentProductRequestUrl(),
  timeout: request.timeout, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  cfg => {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    cfg.headers['token'] = PUBLIC_TOKEN;
    cfg.headers['AppSource'] = 'H5';
    return Promise.resolve(cfg);
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  res => {
    return Promise.resolve(res.data);
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
